import BaseState from 'Engine/base/states/BaseState';
import GlobalDispatcher from '../libs/game-engine/src/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';
import EntryPoint from 'Engine/EntryPoint';

export default class ResetBonusFieldState extends BaseState {

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add(eEventTypes.EET_RESET_BONUS_FIELD__COMPLETE, this.complete.bind(this));
  }

  start() {
    super.start();
    EntryPoint.GameModel.lastJackpotsCount = 0;
  }

  complete() {
    if (this.active) {
      super.complete();
    }
  }
}
